import React from 'react';

const About = () => {
    return (
        <div>
            ablout page
        </div>
    );
};

export default About;